module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elGrade5512_play_icon_196464.9e013eb9.jpg";